import React from 'react';
import { TableCell, Container, Typography, TableContainer, Paper, Table, TableHead, TableRow, TableBody } from '@mui/material';

const TSCell=({rowSpan,children,sx={},typo="body1"})=>{
	const simpleChildren=(typeof children)==='string' || (typeof children)==='number';
	//console.log(children,typeof children, simpleChildren);
	return(
		<TableCell sx={sx} rowSpan={rowSpan}>
			{simpleChildren?
				<Typography variant={typo}>{children}</Typography>
			:	children
			}
		</TableCell>
	);
};

const TSHead=({children})=>(
	<TableCell><Typography variant="h5">{children}</Typography></TableCell>
);

const TSTable=({title,headings,children,style,sx})=>(
	<Container style={style} disableGutters={true} sx={sx}>
		<Typography variant="h4">{title}</Typography>
		<TableContainer component={Paper}>
			<Table>
				<TableHead>
					<TableRow>
						{headings && headings.map((h,i)=><TSHead key={i}>{h}</TSHead>)}
					</TableRow>
				</TableHead>
				<TableBody>
					{children}
				</TableBody>
			</Table>
		</TableContainer>
	</Container>
);

export { TSCell, TSHead, TSTable };
